<template>
  <labeled-form-control label="Medical Notes">
    <textarea v-model="medicalNoteText" class="form-control" cols="50" placeholder="Add notes (optional)" rows="5"></textarea>
  </labeled-form-control>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetMedicalNote',
  props: {
    petId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'findPetNote'
    ]),
    noteTypeId () {
      return 3
    },
    note () {
      return this.findPetNote(this.petId, this.noteTypeId)
    },
    medicalNoteText: {
      get () {
        return this.note?.noteText || ''
      },
      set (value) {
        this.updatePetNote({ petId: this.petId, noteTypeId: this.noteTypeId, value })
      }
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updatePetNote'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
